var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCellPhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "104px",
    height: "162px",
    viewBox: "0 0 104 162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Cell Phone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Work",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Landing-Page-(Desktop)",
    transform: "translate(-409.000000, -458.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cell-Phone",
    transform: "translate(410.000000, 459.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.15288231,0.0727539063 L94,0.0727539063 L94,0.0727539063 L98,0.0727539063 C100.209139,0.0727539063 102,1.86361491 102,4.07275391 L102,156 C102,158.209139 100.209139,160 98,160 L94,160 L94,160 L9.85274583,160 C7.70195977,160 5.93619236,158.299237 5.85555792,156.149963 L0.155694399,4.22271664 C0.0728722663,2.01513072 1.79533365,0.15838813 4.00291957,0.0755659975 C4.05288518,0.0736914348 4.10288155,0.0727539063 4.15288231,0.0727539063 Z",
    id: "Rectangle",
    stroke: "#8D919B",
    fill: "#8D919B",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#8D919B",
    fill: "#FFFFFF",
    strokeLinecap: "round",
    x: 0,
    y: 0,
    width: 94,
    height: 160,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#8D919B",
    x: 0,
    y: 137,
    width: 94,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#8D919B",
    x: 0,
    y: 14,
    width: 94,
    height: 1
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#8D919B",
    cx: 47,
    cy: 149,
    r: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#8D919B",
    fill: "#28CAF4",
    strokeLinecap: "round",
    x: 8,
    y: 41,
    width: 72,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    stroke: "#8D919B",
    fill: "#FFFFFF",
    strokeLinecap: "round",
    x: 8,
    y: 87,
    width: 72,
    height: 8,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    stroke: "#8D919B",
    fill: "#DBF3FB",
    strokeLinecap: "round",
    x: 8,
    y: 103,
    width: 60,
    height: 8,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#8D919B",
    fill: "#DBF3FB",
    strokeLinecap: "round",
    x: 8,
    y: 71,
    width: 41,
    height: 8,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#8D919B",
    x: 36,
    y: 6,
    width: 23,
    height: 2,
    rx: 1
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellPhone);
export default __webpack_public_path__ + "static/media/cell-phone.76ca2c57.svg";
export { ForwardRef as ReactComponent };